import { geometry } from "@progress/kendo-drawing";
export class Box {
    constructor(x1, y1, x2, y2) {
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    width() {
        return this.x2 - this.x1;
    }
    height() {
        return this.y2 - this.y1;
    }
    pad(padding) {
        const spacing = { ...padding };
        this.x1 -= spacing.left;
        this.x2 += spacing.right;
        this.y1 -= spacing.top;
        this.y2 += spacing.bottom;
        return this;
    }
    unpad(padding) {
        const spacing = { ...padding };
        spacing.left = (-spacing.left) || 0; // avoid -0 values
        spacing.top = (-spacing.top) || 0;
        spacing.right = (-spacing.right) || 0;
        spacing.bottom = (-spacing.bottom) || 0;
        return this.pad(spacing);
    }
    toRect() {
        return new geometry.Rect([this.x1, this.y1], [this.width(), this.height()]);
    }
}
